/*
*
* File JS Principale
*
*/
// IMPORT JQUERY
//--------------------------------------------------------------------//

import $ from 'jquery';


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import 'scss/app.scss';

//--------------------------------------------------------------------//

// Carichiamo i font in maniera asincrona
//--------------------------------------------------------------------//


/*
var Webfont = require('webfontloader');
Webfont.load(
{
    google:
    {
        families: ['Outfit:400,500,700,900&display=swap']
    }
});
*/


window.WebFontConfig =
{
    typekit: { id: 'jfh0vsm' }
};

(function(d)
{
    var wf = d.createElement('script'), s = d.scripts[0];
    wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
    wf.async = true;
    s.parentNode.insertBefore(wf, s);
})(document);


// Variabili globali
//--------------------------------------------------------------------//

window.IM_GLOBAL =
{
    resolutions:
    {
        mobile:             0,
        tabletPortrait:   768,
        tabletLandscape: 1024,
        desktopExtended: 1441,
        headerExpanded:  1025
    },
    size:
    {
        paddingMobile:    30,
        paddingTablet:    30,
        paddingDesktop:   40
    }
};

//--------------------------------------------------------------------//


// Libreria Lazysizes
//--------------------------------------------------------------------//
import 'lazysizes';

//--------------------------------------------------------------------//

// Import Utilies
//--------------------------------------------------------------------//

/*
import { initSvgImage } from './utilities/img-svg';
import smoothScroll from './utilities/smooth-scroll';
import initAnimations from './utilities/animations';
*/

//--------------------------------------------------------------------//


// Init Utilies
//--------------------------------------------------------------------//

/*
initSvgImage();
smoothScroll();
initAnimations();
*/

//--------------------------------------------------------------------//

//import videoNoPoster from './plugins/im-video-no-poster';


// Import Componenti
//--------------------------------------------------------------------//

import socialMenu from 'components/social-menu/social-menu';
import header from 'components/header/header';
import footer from 'components/footer/footer';

//--------------------------------------------------------------------//


// Init Componenti
//--------------------------------------------------------------------//

window.addEventListener('DOMContentLoaded', (evt) =>
{
    header();
});

//--------------------------------------------------------------------//